import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Zoom from "../../../utilerias/zoom.json";

const LightboxComponent = (props) => {

  return (
    <Fragment>
      {props.isOpen && (
        <Lightbox
          mainSrc={Zoom[props.posicion1].zoom[props.posicion2].zoom}
          onCloseRequest={() => props.lightbox()}
        />
      )}
    </Fragment>
  );
};

LightboxComponent.propTypes = {
  posicion1: PropTypes.number,
  posicion2: PropTypes.number,
  lightbox: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default LightboxComponent;
